import styled from "styled-components";
import React, { useState, useEffect } from "react";
import { modularOutcomeTypeQuestion } from "constants/questionTypes";
import {words} from '../translations'
import SkipCheckbox from './SkipCheckbox';
import { use } from "i18next";
// ... styled-components code ...

const SliderOutcome = ({
  id,
  resetResponsesOnChange,
  question,
  saveUpdatedAnswers,
  currentQuestionDet,
  questionSequenceMap,
  language
}) => {
  const [sliderValue, setSliderValue] = useState(5);
  const [isDragging, setIsDragging] = useState(false);
  const [clickedVal, setClickedVal] = useState(false);
  const [sliderScale, setSliderScale] = useState(question.scale);
  const [sliderWords, setSliderWords] = useState(words);
  const [isNA, setNA] = useState(false);

  useEffect(() => {
    if (question.scale) {
      setSliderScale(question.scale);
    }
  }, [question]);
  

  useEffect(() => {
    const handleMouseMove = (e) => {
      if (!isDragging) return;

      const track = document.getElementById("slider-track");
      const trackRect = track.getBoundingClientRect();
      let newValue = ((e.clientX - trackRect.left) / trackRect.width) * 10;

      newValue = Math.min(Math.max(newValue, 0), 10);

      setSliderValue(newValue);
      saveValue(newValue);
    };

    const handleMouseUp = () => {
      if (!isDragging) return;
      setIsDragging(false);
      if (isNA || sliderValue === null || Number.isNaN(sliderValue)) return;
      const newValue = Math.round(sliderValue);
      setSliderValue(newValue);
      saveValue(newValue);
    };

    const handleTouchMove = (e) => {
      if (!isDragging) return;

      const track = document.getElementById("slider-track");
      const trackRect = track.getBoundingClientRect();
      let newValue =
        ((e.touches[0].clientX - trackRect.left) / trackRect.width) * 10;

      newValue = Math.min(Math.max(newValue, 0), 10);

      setSliderValue(newValue);
      saveValue(newValue);
    };

    const handleTouchEnd = () => {
      if (!isDragging) return;
      setIsDragging(false);
      if (isNA || sliderValue === null || Number.isNaN(sliderValue)) return;
      const newValue = Math.round(sliderValue);
      setSliderValue(newValue);
      saveValue(newValue);
    };

    window.addEventListener("mousemove", handleMouseMove);
    window.addEventListener("mouseup", handleMouseUp);
    window.addEventListener("touchmove", handleTouchMove);
    window.addEventListener("touchend", handleTouchEnd);

    return () => {
      window.removeEventListener("mousemove", handleMouseMove);
      window.removeEventListener("mouseup", handleMouseUp);
      window.removeEventListener("touchmove", handleTouchMove);
      window.removeEventListener("touchend", handleTouchEnd);
    };
  }, [isDragging, sliderValue, isNA]);

  useEffect(() => {
    const respObj = (currentQuestionDet && typeof currentQuestionDet.response === 'object') ? currentQuestionDet.response : null;
    const respVal = respObj?.response ?? null;

    if (respVal === 'N/A') {
      setNA(true);
      setSliderValue(null);
    } else if (respVal === null || respVal === undefined) {
      setSliderValue(5);
      setClickedVal(false);
      setNA(false);
    } else {
      setSliderValue(respVal);
      setClickedVal(true);
      setNA(false);
    }
  }, [currentQuestionDet]);

  const saveValue = (newValue) => {
    if (isNA) return;
    setClickedVal(true);
    //
    SaveResponse(newValue);
  };

  const handleClick = (e) => {
    const track = document.getElementById("slider-track");
    // const track = document.getElementById(id);
    const rect = track.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const newValue = Math.round((x / rect.width) * 10);
    setSliderValue(newValue);
    setClickedVal(true);
    setNA(false);
    //
    SaveResponse(newValue);
  };

  const handleNAClick = () => {
    if (!isNA) {
      // Selecting N/A
      setNA(true);
      setSliderValue(null);

      setClickedVal(true);
      SaveResponse('N/A');
    } else {
      // Deselecting N/A - We need to properly reset the state
      setNA(false);
      setSliderValue(null);
      
      // Create a response object that indicates no selection was made
      const QuesResp = {
        id: question?.dimension,
        factor: question?.factor,
        q: question?.q,
        ques_order: question?.order,
        response: null,
        role: question?.role,
        reverse: question?.reverse || false,
        clicked: false, // Mark as not clicked/selected
        ques_sort_order: currentQuestionDet?.id,
        importance: question?.importance || null,
      };
      
      // Pass the complete QuesResp object to ensure next button state is updated correctly
      saveUpdatedAnswers(currentQuestionDet.id, QuesResp, modularOutcomeTypeQuestion);
    }
  };


  // save the response
  function SaveResponse(newValue) {
    // reset associated questions
    // check if value changed
    if (currentQuestionDet?.response &&
      currentQuestionDet?.response?.response !== newValue) {
      if (currentQuestionDet?.resetOnChange) {
        // resetResponsesOnChange
        if (resetResponsesOnChange[currentQuestionDet?.id]) {
          // reset the responses to each of the linked questions
          // console.log(resetResponsesOnChange[currentQuestionDet?.id]);
          resetResponsesOnChange[currentQuestionDet?.id].map((sq) => {
            questionSequenceMap[sq].response = false;
            questionSequenceMap[sq].clicked = false;
            return null;
          });
        }
      }
    }

    const QuesResp = {
      order: currentQuestionDet?.id,
      clicked: true,
      s: currentQuestionDet?.s,
      q: currentQuestionDet?.q,
      id: currentQuestionDet?.id,
      ques_order: currentQuestionDet?.id,
      scale: question?.scale,
      question: question?.question,
      response: newValue,
      ques_sort_order: currentQuestionDet?.id,
    };

    console.log("newValue", newValue);
    saveUpdatedAnswers(
      currentQuestionDet.id,
      QuesResp,
      modularOutcomeTypeQuestion
    );
  }

  // Add a function to interpolate between two colors
  const lerpColor = (color1, color2, t) => {
    const r = color1.r + t * (color2.r - color1.r);
    const g = color1.g + t * (color2.g - color1.g);
    const b = color1.b + t * (color2.b - color1.b);
    return { r, g, b };
  };

  // Add a function to calculate the thumb color
  const getThumbColor = () => {
    const color1 = { r: 248, g: 168, b: 176 };
    const color2 = { r: 254, g: 205, b: 141 };
    const color3 = { r: 149, g: 230, b: 210 };
    const t = sliderValue / 10;

    if (t < 0.5232) {
      const newT = t / 0.5232;
      const interpolatedColor = lerpColor(color1, color2, newT);
      return `rgb(${interpolatedColor.r}, ${interpolatedColor.g}, ${interpolatedColor.b})`;
    } else {
      const newT = (t - 0.5232) / (1 - 0.5232);
      const interpolatedColor = lerpColor(color2, color3, newT);
      return `rgb(${interpolatedColor.r}, ${interpolatedColor.g}, ${interpolatedColor.b})`;
    }
  };

  const handleMouseDown = () => {
    setIsDragging(true);
  };

  const handleTouchStart = () => {
    setIsDragging(true);
  };

  const thumbPosition = {
    left: `calc(${(sliderValue / 10) * 100}% - 10px )`,
  };

  const dotCount = 11;
  const dots = Array.from({ length: dotCount }, (_, index) => (
    <Dot
      key={index}
      style={{ left: `${(index / (dotCount - 1)) * 100}%` }}
      id={`dot_${(index / (dotCount - 1)) * 10}_${id}`}
    />
  ));

  

  const get_slider_words = (text) => {
    if (words[text]) {
      return words[text][language];
    }

    return text;

  }

  return (
    <Container>
      <TrackWrapper
        onClick={handleClick}
        onMouseDown={handleMouseDown}
        onTouchStart={handleTouchStart}
      >
        <Track id={"slider-track"}>
          <DotsContainer id={`dots_${id}`}>{dots}</DotsContainer>
          {!isNA && <Thumb
            style={{
              ...thumbPosition,
              backgroundColor: getThumbColor(),
            }}
            onMouseDown={handleMouseDown}
            onTouchStart={handleTouchStart}
            id={`thumb_${id}`}
          >
            <Tooltip clicked={clickedVal} id={`tip_${id}`}>
              {Math.round(sliderValue)}
              <Triangle />
            </Tooltip>
          </Thumb>
          }
        </Track>
      </TrackWrapper>

      <ScaleLabelsContainer>
        <ScaleLabel>
          {sliderScale.length > 0 ? get_slider_words(sliderScale[0]) : "Strongly Disagree"}
        </ScaleLabel>
        <ScaleLabel>
          {sliderScale.length > 2 ?get_slider_words(sliderScale[1]) : words["Neutral"][language]}
        </ScaleLabel>
        <ScaleLabel>
          {sliderScale.length > 1
            ? get_slider_words(sliderScale[sliderScale.length - 1])
            : "Strongly Agree"}
        </ScaleLabel>
      </ScaleLabelsContainer>

      {question?.allowSkip && (
        <SkipCheckbox
          id={`skip_${currentQuestionDet?.id}`}
          selected={isNA}
          onClick={handleNAClick}
          language={language}
        />
      )}
    </Container>
  );
};

export default SliderOutcome;

const Container = styled.div`
  width: 100%;
  padding-top: 70px;
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
`;

const ScaleLabel = styled.span`
  font-size: 14px;
`;

const SliderContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`;

const ScaleLabelsContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin-top: 8px;
`;

const TrackWrapper = styled.div`
  position: relative;
  height: calc(10px + 10px); // 5px above and below the track area
  cursor: pointer;
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
`;

const Track = styled.div`
  width: 100%;
  height: 6px;
  background: linear-gradient(
    to right,
    #f8a8b0 0%,
    #fecd8d 52.32%,
    #95e6d2 100%
  );
  position: relative;
  border-radius: 5px;
  cursor: pointer;
`;

const Thumb = styled.div`
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-color: #000;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  user-select: none;
  border: 4px solid white;
  box-shadow: 0px 8px 20px rgba(63, 134, 254, 0.08);
`;

const Tooltip = styled.div`
  position: absolute;
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%);
  background: #666d79;
  border-radius: 8px;
  width: 33px;
  height: 29px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${(props) => (props.clicked ? "#FFFFFF" : "#D6DBDF")};
  font-size: 14px;
  font-weight: ${(props) => (props.clicked ? "700" : " 400")};
  margin-bottom: 8px; // 8px above the track
`;

const Triangle = styled.div`
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 4px 4px 0;
  border-color: #666d79 transparent transparent;
`;

const DotsContainer = styled.div`
  position: absolute;
  top: 50%;
  left: 0;
  right: 0;
  height: 1px;
  display: flex;
  justify-content: space-between;
`;

const Dot = styled.div`
  width: 4px;
  height: 4px;
  background-color: #fff;
  border-radius: 50%;
  position: absolute;
  transform: translateY(-50%);
`;



const NA = styled.div`
  font-size: 12px;
  font-weight: bold;
  font-family: "Barlow", sans-serif;
  background-color: ${props => props.selected ? '#D5E2F9' : '#fff'};
  color: #333;
  height: 30px;
  border-radius: 8px;
  justify-content: center;
  align-items: center;
  display: flex;
  width: 75px;
  margin-top: 50px;
  cursor: pointer;
  margin-right: -20px;
  transition: all 0.3s ease;
  border: 2px solid ${props => props.selected ? '#2D70E2' : 'transparent'};
  
  &:hover {
    background-color: #D5E2F9;
  }

  @media(max-width:768px){
    margin-right: -10px;
  }
`
